import { render } from "./CRMWhatsappConversationNoteDialog.vue?vue&type=template&id=4f9bd800&scoped=true"
import script from "./CRMWhatsappConversationNoteDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappConversationNoteDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappConversationNoteDialog.vue?vue&type=style&index=0&id=4f9bd800&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9bd800"]])

export default __exports__